import React from 'react';
interface TextAreaValueProps {
    value: TextAreaProps;
  }
interface TextAreaProps {
  label: string;
  text: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}

const TextArea: React.FC<TextAreaValueProps> = ({value}) => {
    const { label, text, onChange, placeholder, className, inputClassName } = value;
  return (
    <div className={`flex flex-col ${className}`}>
      {label ? <label className="open-sans-normal mb-2">{label}</label> : null}
      <textarea
        value={text}
        onChange={onChange}
        placeholder={placeholder}
        className={inputClassName}
      />
    </div>
  );
};

export default TextArea;